import { Flex, Spinner } from '@radix-ui/themes';
import { observer } from 'mobx-react-lite';

import './table-loader-overlay.scss';

export const TableLoaderOverlayView = ({ show, colSpan }: { show: boolean; colSpan: number }) => {
   if (!show) {
      return null;
   }
   return (
      <tr className="table-overlay" >
         <td className='table-overlay__cell' colSpan={colSpan}>
            <Flex className="table-overlay-loader" align="center" justify="center">
               <Spinner size="3" />
            </Flex>
         </td>
      </tr>
   );
};

export const TableLoaderOverlay = observer(TableLoaderOverlayView);
